import React from "react";
import "./index.scss";
import { Point } from "@/routes/Frontend/FuturebilityCockpit/types";
import { getPosition } from "../personality-matrix-advanced/utils";

interface PersonalityMatrixProps {
  points?: Point[];
  activeGridIndex: number;
  gridLabels?: string[];
  mainLabels?: { left: string; right: string; top: string; bottom: string };
}

const Indicator = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      {...props}
    >
      <path
        d="M10 10.3872C7.22505 10.3872 4.97505 8.21221 4.97505 5.51221C4.97505 2.81221 7.22505 0.637207 10 0.637207C12.775 0.637207 15.0251 2.81221 15.0251 5.51221C15.0251 8.21221 12.775 10.3872 10 10.3872Z"
        fill="#00EBC8"
      />
      <path
        d="M7.56255 12.0747H12.4375C16.4501 12.0747 19.7125 15.3747 19.7125 19.3872V22.4997C19.7125 22.9497 19.3375 23.3622 18.85 23.3622C18.3626 23.3622 17.6223 23.3622 17.6223 23.3622H16.3687C16.3687 23.3622 14.7038 23.3622 11.5913 23.3622H7.00005C3.92505 23.3622 3.50005 23.3622 3.50005 23.3622H2.3246C2.3246 23.3622 1.52505 23.3622 1.03755 23.3622C0.550049 23.3622 0.175049 22.9872 0.175049 22.4997V19.3872C0.287549 15.3747 3.55005 12.0747 7.56255 12.0747Z"
        fill="#00EBC8"
      />
    </svg>
  );
};

export const PersonalityMatrix: React.FC<PersonalityMatrixProps> = ({
  points = [],
  activeGridIndex = 0,
  gridLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
  mainLabels = { left: "left", right: "right", top: "top", bottom: "bottom" },
}) => {
  return (
    <div className="personality-matrix">
      <div className="inner-container">
        <div className="main-label left">{mainLabels.left}</div>
        <div className="chart-container">
          <div className="axes">
            <div className="main-label axis top">{mainLabels.top}</div>
            <div className="main-label axis bottom">{mainLabels.bottom}</div>
          </div>

          <div className="corners">
            <div className="corner top-left" />
            <div className="corner top-right" />
            <div className="corner bottom-left" />
            <div className="corner bottom-right" />
          </div>

          <div className="grid">
            {Array.from({ length: gridLabels.length }, (_, index) => (
              <div key={index} className="grid-item">
                <div
                  className={`grid-label ${
                    index === activeGridIndex ? "highlighted" : ""
                  }`}
                >
                  {gridLabels[index]}
                </div>
              </div>
            ))}
          </div>

          <div className="cross-lines">
            <div className="cross-line horizontal" />
            <div className="cross-line vertical" />
          </div>

          {points.map((p, i) => (
            <Indicator
              key={i}
              className="indicator"
              style={getPosition(p.x, p.y)}
            />
          ))}
        </div>
        <div className="main-label right">{mainLabels.right}</div>
      </div>
    </div>
  );
};
